import React, { useState } from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import { exportToCsv } from '../utils/exportUtils';
import { Download } from '../icons';

export function SearchableTable({
  data,
  tableSize,
  tableFixed,
  caption,
  className,
  wrapperClassName,
  ariaLabel = 'Przewijalna zawartość tabeli',
  showExportButton = true,
  exportFilename = 'tabela',
}) {
  const [searchTerm, setSearchTerm] = useState('');

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleExportCsv = () => {
    if (data && data.length > 0) {
      exportToCsv(data, `${exportFilename}.csv`);
    }
  };

  const headers = data ? Object.keys(data[0]) : [];
  const dataFiltered = data?.filter((el) => {
    return searchTerm
      ? Object.values(el).some((val) => {
          return val
            .toString()
            .toLowerCase()
            .includes(searchTerm.toLowerCase());
        })
      : data;
  });

  return (
    <div className="relative">
      {/* <div
        className={clsx('flex', caption && 'w-full justify-between items-end')}
      >
        {caption && (
          <span className="text-lg font-semibold mt-0">{caption}</span>
        )}
        <label className="input input-bordered flex items-center gap-2">
          <input
            type="text"
            className="grow"
            placeholder="Wyszukaj"
            value={searchTerm}
            onInput={handleInputChange}
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            className="h-4 w-4 opacity-70"
          >
            <path
              fillRule="evenodd"
              d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
              clipRule="evenodd"
            />
          </svg>
        </label>
      </div> */}
      <div
        className={twMerge('overflow-x-auto', wrapperClassName)}
        tabIndex="0"
        role="region"
        aria-label={ariaLabel}
      >
        <table
          className={twMerge(
            clsx(
              'table mt-0',
              tableSize && tableSize,
              tableFixed && 'table-fixed',
            ),
            className,
          )}
        >
          <thead>
            <tr className={tableSize == 'table-lg' && 'text-sm'}>
              {headers.map((header) => (
                <th key={header}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {dataFiltered.map((row, i) => (
              <tr key={'row' + i}>
                {headers.map((header, i) => (
                  <td key={header + i}>{row[header]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showExportButton && data && data.length > 0 && (
        <div className="flex justify-end mt-4">
          <button
            onClick={handleExportCsv}
            className="btn btn-sm btn-success"
            title="Eksportuj jako CSV"
            aria-label="Eksportuj tabelę jako CSV"
          >
            <Download className="h-4 w-4" />
            Eksportuj CSV
          </button>
        </div>
      )}
    </div>
  );
}
